export const RESET_OBJ = "RESET_OBJ";
export const RESET_STATUS = "RESET_STATUS";
export const API_ERROR = "MESSAGES_API_ERROR";

export const GET_MESSAGES = "GET_MESSAGES";
export const SET_MESSAGES = "SET_MESSAGES";
export const GET_MESSAGE = "GET_MESSAGE";
export const SET_MESSAGE = "SET_MESSAGE";
export const SET_AI_MESSAGE = "SET_AI_MESSAGE";

export const SEND_MESSAGE = "SEND_MESSAGE";
export const SENT_MESSAGE = "SENT_MESSAGE";

export const CLOSE_CHAT = "CLOSE_CHAT";
export const CLOSED_CHAT = "CLOSED_CHAT";

export const GET_TABS_CHAT = "GET_TABS_CHAT";
export const SET_TABS_CHAT = "SET_TABS_CHAT";

export const TABULATE_CHAT = "TABULATE_CHAT";
export const TABULATE_CHAT_TICKET = "TABULATE_CHAT_TICKET";
export const TABULATED_CHAT = "TABULATED_CHAT";

export const DISABLE_CHAT = "DISABLE_CHAT";
export const DISABLED_CHAT = "DISABLED_CHAT";

export const RESET_CONSUMER_OBJ = "RESET_CONSUMER_OBJ";
export const RESET_CONSUMER_STATUS = "RESET_CONSUMER_STATUS";
export const GET_CONSUMER_ERROR = "GET_CONSUMER_ERROR";
export const GET_CONSUMER_CONVERSATIONS = "GET_CONSUMER_CONVERSATIONS";
export const SET_CONSUMER_CONVERSATIONS = "SET_CONSUMER_CONVERSATIONS";
export const GET_CONSUMER_MESSAGES = "GET_CONSUMER_MESSAGES";
export const SET_CONSUMER_MESSAGES = "SET_CONSUMER_MESSAGES";

export const SEND_INACTIVITY_MSG = "SEND_INACTIVITY_MSG";
export const SENT_INACTIVITY_MSG = "SENT_INACTIVITY_MSG";

export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const UPDATE_UNREAD_MSG = "UPDATE_UNREAD_MSG";

export const START_OBSERVER = "START_OBSERVER";
export const STARTED_OBSERVER = "STARTED_OBSERVER";

export const UPLOAD_FILE = "UPLOAD_FILE";
export const UPLOADED_FILE = "UPLOADED_FILE";

export const JOIN_CONVERSATION = "JOIN_CONVERSATION";
export const JOINED_CONVERSATION = "JOINED_CONVERSATION";

export const SAVE_MESSAGE = "SAVE_MESSAGE";
export const SAVE_SCROLL = "SAVE_SCROLL";
export const REMOVE_SCROLL_MESSAGE = "REMOVE_SCROLL_MESSAGE";

export const GET_SKILLS_ATTENDANCE = "GET_SKILLS_ATTENDANCE";
export const SET_SKILLS_ATTENDANCE = "SET_SKILLS_ATTENDANCE";
export const CREATE_ATTENDANCE = "CREATE_ATTENDANCE";
export const CREATED_ATTENDANCE = "CREATED_ATTENDANCE";

export const CREATE_COMMENTARY = "CREATE_COMMENTARY";
export const CREATE_COMMENTARY_SUCCESS = "CREATE_COMMENTARY_SUCCESS";
export const CREATE_COMMENTARY_FAILURE = "CREATE_COMMENTARY_FAILURE";

export const DELETE_COMMENTARY = "DELETE_COMMENTARY";
export const DELETE_COMMENTARY_SUCCESS = "DELETE_COMMENTARY_SUCCESS";
export const DELETE_COMMENTARY_FAILURE = "DELETE_COMMENTARY_FAILURE";
